import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { FiltroInformeNhCenso } from '../../../domain/model/no-hospitalario/informes/entity/filtro-informe-nh-censo.model';
import { TipoInformeNh } from '../../../domain/model/no-hospitalario/informes/entity/tipo-informe.model';
import { InformesNhGateway } from '../../../domain/model/no-hospitalario/informes/gateway/informes-nh-gateway';
import { HttpParams, HttpClient } from '@angular/common/http';
import { ArchivoInformeResult } from '../../response-model/informes/informe-descarga.response';

@Injectable({
  providedIn: 'root'
})
export class InformesNhService extends InformesNhGateway {

  private readonly url: string;
  private readonly port: string;

  constructor(private readonly http: HttpClient) {
    super();
    this.url = `${environment.apiBaseUrl}`;
    this.port = `${environment.portBaseUrl}`;
  }

  public consultarInformeNhCenso(filtros: FiltroInformeNhCenso): Observable<ArchivoInformeResult> {
    const URL = `${this.url}${this.port}/api_informes/informes/informeCensoNoHospitalario`;
    return this.http.get<ArchivoInformeResult>(URL, { params: this.setParamsNh(filtros) });
  }

  public consultarInformeNhRespaldoProgramacion(filtros: FiltroInformeNhCenso): Observable<ArchivoInformeResult> {
    const URL = `${this.url}${this.port}/api_informes/informes/informeRespaldoProgramacionNH`;
    return this.http.get<ArchivoInformeResult>(URL, { params: this.setParamsNh(filtros) });
  }

  public consultarInformesNh(codigoTipo: number): Observable<TipoInformeNh[]> {
    const url = `${this.url}${this.port}/api_ingreso/tipo-informe`;
    return this.http.get<TipoInformeNh[]>(`${url}/${codigoTipo}`);
  }

  private setParamsNh(filtros: FiltroInformeNhCenso): HttpParams {
    let params = new HttpParams();
    if (filtros.idCiudad != null && filtros.idCiudad !== '') {
      params = params.set('ciudad', filtros.idCiudad);
    }
    if (filtros.idTipoAtencion !== '') {
      params = params.set('tipoServicio', filtros.idTipoAtencion);
    }
    if (filtros.fechaInicio != null && filtros.fechaInicio !== '') {
      params = params.set('desde', filtros.fechaInicio);
    }
    if (filtros.fechaFin != null && filtros.fechaFin !== '') {
      params = params.set('hasta', filtros.fechaFin);
    }
    return params;
  }
}
